import React from 'react';
import { Button, ButtonBase } from '@material-ui/core';
import LoadingButton from '@mui/lab/LoadingButton';

export const PrimaryButton = ({
  type = 'small',
  color = 'green',
  text = '',
  font = '',
  fstyle = '',
  fweight = '',
  fcolor = '',
  transform = '',
  action = () => {},
  isDisabled = false,
  textBold = false,
  fsize = '14',
  isLoading = false,
  variant = 'default',
  subTitle = '',
  newStyle,
}) => (
  <>
    {/* {!isLoading ? (
      <Button
    type="submit"
    style={{ color: { fcolor }, background: 'white' }}
      className={`primary-btn ${type} ${color} ${font} ${fstyle} ${fweight} ${fcolor} fs-${fsize} ${textBold ? 'text-bold' : ''} ${'textTransform' + transform} `}
      onClick={action}
      disabled={isDisabled}>
        {text || 'Submit'}
      </Button>
    ) : <LoadingButton loading variant="outlined" />} */}
    <Button
      type="submit"
      style={{
        color: { fcolor }, background: 'white', height: variant === 'outline' ? '68px' : '', width: newStyle ? '100%' : '',
      }}
        className={`${variant === 'outline' ? 'primary-outline-btn' : 'primary-btn'} ${type} ${color} ${font} ${fstyle} ${fweight} ${fcolor} fs-${fsize} ${textBold ? 'text-bold' : ''} ${'textTransform' + transform} `}
        onClick={action}
        disabled={isDisabled}>

      {isLoading ? <LoadingButton loading variant="outlined" />
        : variant === 'default' ? text
          : (
            <div className="content">
              <div className="main-title fw-bold fs-17 lh-20">
                {text || 'Submit'}
              </div>
              <div className="sub-title fs-11 lh-18">
                {subTitle || ''}
              </div>
            </div>
          )
          || 'Submit'}
    </Button>
  </>
);
 
export default PrimaryButton;
